import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { push } from 'react-router-redux';

// Components
import ExtComp from '../../components/external';
import NewJobWrapper from '../../components/NewJobWrapper/NewJobWrapper';
import MultiSelectTable from '../../components/MultiSelectTable/MultiSelectTable';

// Actions
import { updateFilters, loadAppointmentsByDoctorIdAndDate } from '../../reducer/createNewJobActions';

// Services
import { filterAppointsByCampus, updateAppointsStatuses } from 'src/views/practitioner/services/appointments';
import { filterAppointsByStatusesWithCovid } from './NewJobAppointmentsList.services';

// Styles
import s from './NewJobAppointmentsList.style';


const NewJobAppointmentsList = (props) => {
  const {
    appointmentsList,
    campusesList, practitionersList,
    campusId, date, practitionerId, selectedList, activeAppointStatuses,
    dispatch,
    info,
    t
  } = props;

  const [filterAppointmentsList, setFilterAppointmentsList] = useState([]);

  const goToNextScreen = () => {
    if (info) {
      let nextUrl;
      if (info.type === 'communicate') {
        nextUrl = '/practitioner/new-job/details';
      } else if (info.type === 'reschedule') {
        nextUrl = '/practitioner/new-job/reschedule-details';
      }
      dispatch(push(nextUrl));
    }
  };

  const onChangeFilter = (target, value) => {
    dispatch(updateFilters({ [target]: value }));
    if (target !== 'selectedList') { // reset selected list for any changes
      dispatch(updateFilters({ selectedList: [] }));
    }
  };

  const onChangeAppointsStatuses = (statuses) => {
    onChangeFilter('activeAppointStatuses', updateAppointsStatuses(activeAppointStatuses, statuses));
  };

  // filter slots if campus changed or loaded new list
  useEffect(() => {
    const filterByCampus = filterAppointsByCampus(appointmentsList, campusId);
    const filterByStatus = filterAppointsByStatusesWithCovid(filterByCampus, activeAppointStatuses);
    setFilterAppointmentsList(filterByStatus);
  }, [campusId, appointmentsList, activeAppointStatuses]);

  // load new list if changed doctor or date but not reload after back to screen
  const isFirstLoaded = useRef(false);
  useEffect(() => {
    if (practitionerId && date && appointmentsList === null && !isFirstLoaded.current) {
      isFirstLoaded.current = true;
      dispatch(loadAppointmentsByDoctorIdAndDate(practitionerId, date));
    } else if (practitionerId && date && appointmentsList && !isFirstLoaded.current) {
      isFirstLoaded.current = true;
    } else if (practitionerId && date && isFirstLoaded.current) {
      dispatch(loadAppointmentsByDoctorIdAndDate(practitionerId, date));
    }
  }, [practitionerId, date]);

  //──── Select items ──────────────────────────────────────────────────────────────────────
  const triggerSelection = (id) => {
    let list;
    if (selectedList.includes(id)) {
      list = selectedList.filter(apId => apId !== id);
    } else {
      list = [...selectedList, id];
    }
    onChangeFilter('selectedList', list);
  };

  const triggerGeneralSelector = () => {
    let list = selectedList.length === 0 ? filterAppointmentsList.map(ap => ap.id) : [];
    onChangeFilter('selectedList', list);
  };

  return (
    <NewJobWrapper
      screenTitle={t('nj_select_appointments_title')}
      percent={50}
      backPath={'/practitioner/new-job'}
      nextBtnAction={goToNextScreen}
      nextBtnDisabled={selectedList.length === 0}
    >

      <s.NewJobListWrapper>

        <div className="filters">
          <ExtComp.PractitionersList
            practitioners={practitionersList}
            practitionerId={practitionerId}
            onChange={(pr) => {
              onChangeFilter('practitionerId', pr.id);
            }}
          />

          <ExtComp.CampusSelect
            campusList={campusesList}
            campusId={campusId}
            onChange={(campus) => {
              onChangeFilter('campusId', campus.id);
            }}
          />

          <ExtComp.AppointmentStatusFilter
            onChange={onChangeAppointsStatuses}
            selectedStatuses={activeAppointStatuses}
            arrayType="newJob"
          />

          <ExtComp.DateFilter
            startDate={date}
            onDateChange={(date) => {
              onChangeFilter('date', date.format());
            }} />
        </div>


        {/* ──── Table ───────────────────────────────────────────────────────────── */}
        <MultiSelectTable
          filterAppointmentsList={filterAppointmentsList}
          selectedList={selectedList}
          triggerSelection={triggerSelection}
          triggerGeneralSelector={triggerGeneralSelector}
          enablePrevDays
        />

      </s.NewJobListWrapper>

    </NewJobWrapper>
  );
};

const mapStateToProps = store => {
  const pr = store.practitioner;
  const filters = pr.createNewJob.filters;
  return {
    appointmentsList: pr.createNewJob.appointmentsList,
    campusId: filters.campusId,
    campusesList: pr.common.campusesList,
    date: filters.date,
    info: pr.createNewJob.info,
    practitionerId: filters.practitionerId,
    practitionersList: pr.common.practitionersList,
    selectedList: filters.selectedList,
    activeAppointStatuses: filters.activeAppointStatuses,
  };
};

export default translate()(
  connect(mapStateToProps)(NewJobAppointmentsList)
);
